import ScopeStackModal from "@components/ScopeStackModal/ScopeStackModal";

interface Props {
  show: boolean;
  credentialNames: string[];
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeleteConfirmModal = ({
  show,
  credentialNames,
  onClose,
  onConfirm,
  isDeleting,
}: Props): JSX.Element => {
  const count = credentialNames.length;
  const plural = count !== 1;
  const title = `Delete Client Credential${plural ? "s" : ""}`;

  const body = (
    <>
      <p>
        You are about to delete {count} client credential{plural ? "s" : ""}.
        Every access token issued against{" "}
        {plural ? "these credentials" : "this credential"} will be immediately
        revoked, and any integration using {plural ? "them" : "it"} will stop
        working.
      </p>
      <ul>
        {credentialNames.map((name, idx) => (
          <li key={idx}>{name}</li>
        ))}
      </ul>
      <p>This action cannot be undone.</p>
    </>
  );

  return (
    <ScopeStackModal
      show={show}
      modalTitle={title}
      modalBody={body}
      handleClose={onClose}
      button1Text="Cancel"
      handleButton1Click={onClose}
      button2Text={isDeleting ? "Deleting…" : "Delete"}
      handleButton2Click={onConfirm}
      button2Disabled={isDeleting}
      deleteModal
    />
  );
};

export default DeleteConfirmModal;
